import { Flex } from "antd";
import { NotificationCategory } from "hooks/queries/notification";
import { useBusinessSettings } from "hooks/queries/business-settings";
import { translate } from "shared/languages";
import { colors } from "shared/theme/color";
import { textPx } from "shared/constants/zoom";

// Wrapping pill row that filters the notification feed by category (prototype's
// Semua / Jadwal bentrok / Booking / Waitlist / Batal). The selected pill takes
// the navy-tint treatment; the rest are quiet hairline chips.
const CATEGORIES: { value: NotificationCategory; labelKey: string }[] = [
  { value: "all", labelKey: "notification.filter.all" },
  { value: "clash", labelKey: "notification.filter.clash" },
  { value: "booking", labelKey: "notification.filter.booking" },
  { value: "waitlist", labelKey: "notification.filter.waitlist" },
  { value: "cancel", labelKey: "notification.filter.cancel" },
  { value: "package", labelKey: "notification.filter.package" },
  { value: "reward", labelKey: "notification.filter.reward" },
];

export const NotificationFilterPills = ({
  value,
  onChange,
  exclude = [],
}: {
  value: NotificationCategory;
  onChange: (next: NotificationCategory) => void;
  // Categories another control on the same surface already filters (the
  // dashboard's activity strip covers booking / waitlist / cancel), so the
  // row never repeats a filter that sits right above it.
  exclude?: NotificationCategory[];
}) => {
  // No Waitlist pill while the studio has its waitlist switched off (older
  // waitlist rows still show under Semua), unless it is the selected one.
  const { data: settings } = useBusinessSettings();
  const hidden =
    settings?.waitlist_enabled === false && value !== "waitlist"
      ? [...exclude, "waitlist" as NotificationCategory]
      : exclude;
  return (
    <Flex wrap="wrap" gap={6}>
      {CATEGORIES.filter((c) => !hidden.includes(c.value)).map((c) => {
        const active = c.value === value;
        return (
          <button
            key={c.value}
            type="button"
            onClick={() => onChange(c.value)}
            style={{
              border: `1px solid ${active ? colors.navy : colors.line}`,
              background: active ? colors.navyTint : colors.card,
              color: active ? colors.navyDark : colors.ink2,
              borderRadius: 999,
              padding: "3px 11px",
              fontSize: textPx(12),
              fontWeight: 600,
              cursor: "pointer",
              transition: "background 120ms ease, border-color 120ms ease",
            }}
          >
            {translate(c.labelKey)}
          </button>
        );
      })}
    </Flex>
  );
};
